import { gql } from '@apollo/client';

export const CREATE_WORKFLOW_COMPLETION = gql`
  mutation createWorkflowCompletion($input: CreateWorkflowCompletionInput!) {
    createWorkflowCompletion(input: $input) {
      workflowCompletion {
        id
        user {
          stringId
        }
      }
    }
  }
`;
